import React, { useState } from 'react';
import images from '../../../../assets/images';
import Button from 'devextreme-react/button';
import Tooltip from 'devextreme-react/tooltip';
import { useTranslation } from 'react-i18next';
import DistanceCalculatorControl from '../distance-calculator/distance-calculator-control/DistanceCalculatorControl';

export default function DistanceCalculatorIcon() {
  const { t } = useTranslation();
  const [isFormVisible, setIsFormVisible] = useState(false);
  return (
    <div className="distance-calculator-control-wrapper">
      <Button
        id="distanceCalculator"
        className="distance-calculator-button"
        onClick={() => setIsFormVisible(true)}
      >
        <img src={images.distanceCalculatorIcon} alt="Distance Calculator" />
        <Tooltip
          target={'#distanceCalculator'}
          showEvent="dxhoverstart"
          hideEvent="dxhoverend"
          position="left"
          contentRender={() => {
            return (
              <div className="m-l-tooltip-wrapper">
                {t('tooltips.distanceCalculator')}
              </div>
            );
          }}
        />
      </Button>
      {isFormVisible && (
        <DistanceCalculatorControl onClose={setIsFormVisible} />
      )}
    </div>
  );
}
